import * as classnames from 'classnames'
import * as React from 'react'

import CollectionIcon from '../../../components/icons/collection'

import * as styles from './collectionButton.module.css'

interface IProps {
  href: string
  onClick: (event: any) => void
  isActive?: boolean
  className?: string
  iconClassName?: string
}

const CollectionButton = ({
  href,
  onClick,
  isActive = false,
  className = '',
  iconClassName = ''
}: IProps) => {
  const classes = classnames({
    [styles.linkActive]: isActive,
    [className]: !!className
  })

  const iconClassNames = classnames(styles.icon, [iconClassName])

  return (
    <a
      role="button"
      href={href}
      className={classes}
      onClick={onClick}
      title="Add to Collection"
      rel="nofollow"
    >
      <CollectionIcon className={iconClassNames} />
    </a>
  )
}

export default CollectionButton
